import { config } from '../index'

const formatCurrency = (number) => {
  return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency })
    .format(number / 100)
}

export default formatCurrency
